/** Wide enough for the full range of dates (DD.MM.YYYY – DD.MM.YYYY) with the calendar icon and the clear button. */
export const TASK_CARD_DEADLINE_COLUMN_WIDTH = '235px';
